import React from "react";
import {copyRight} from "../data";
import ContactInfo from "./ContactInfo";

const Footer = () => {
    return (
        <footer>
            <ContactInfo/>
            <small className="contact-copy">
                {copyRight}
            </small>
        </footer>
    );
};

export default Footer;
